import { nativeAppInterface } from 'src/native_app_interface';
import axios from 'axios';

window.nativeAppInterface = nativeAppInterface;

document.addEventListener('turbo:frame-load', function(event){
  //console.log("TURBO FRAME LOAD: ", event)
  if (event.target.id === 'priorityOverlay') {
    // Remove flag telling others an overlay load is in progress.
    $(event.target).removeClass('loading');
  }
});

window.addEventListener('turbo:before-fetch-request', function(event) {
  //console.log("Turbo before-fetch-request event");
  event.preventDefault();
  event.detail.fetchOptions.credentials = 'include';
  event.detail.resume();
})

window.addEventListener('turbo:before-fetch-response', function(event) {
  if (event.detail.fetchResponse.response.ok == false) {
    const requestId = event.detail.fetchResponse.response.headers.get('X-Request-Id') || '';
    // If it's a 403 error, we want to display the error page in the LDP.
    if (event.target.id === 'priorityOverlay' && event.detail.fetchResponse.response.status === 403) {
      // A hardcoded 403 error page in the event that something breaks here.
      const fallback403Content = getFallback403Content(requestId);

      // Read the ReadableStream from the response body
      event.detail.fetchResponse.response.text().then(responseHtml => {
        // Remove the UIL from the response because it's already loaded and scoped properly.
        // Loading it again causes a bunch of items on the page to flash.
        responseHtml = responseHtml.replace(/<link\b[^>]*>/gi, '');
        
        let errorContent = '';
        errorContent = responseHtml;

        const contentWrapper = `
          <div class="ldp-overlay" data-action="click->ldp-navigation#hideFlexPanelOverlay" style="display: flex; justify-content: center; align-items: center; padding: 20px;">
            <div style="max-width: 600px; width: 100%;">
              ${errorContent}
            </div>
            
          </div>`;

        $(event.target).html(contentWrapper);
        $(event.target).removeClass('loading'); // This must be removed or no other LDP call will load.

      }).catch(err => {
        console.error('Error reading 403 response body:', err);
        $(event.target).html(fallback403Content);
        $(event.target).removeClass('loading');
      });

    } else {
      const fallback500Content = getFallback500Content(requestId);
      let errorResponse = '';

      if (event.target.id === 'priorityOverlay') {
        errorResponse = `
          <div class="ldp-overlay" data-action="click->ldp-navigation#hideFlexPanelOverlay" style="display: flex; justify-content: center; align-items: center; padding: 20px;">
            <div style="max-width: 600px; width: 100%;">
              ${fallback500Content}
            </div>
          </div>
        `;

        $(event.target).html(errorResponse);
        $(event.target).removeClass('loading');
        logErrorToCollect(event);

      } else {
        errorResponse = fallback500Content;
        $(event.target).html(errorResponse);
        logErrorToCollect(event);

      }

    }
  } else if (event.detail.fetchResponse.response.redirected) {
    // We were redirected.  Probably to the login screen.  Reload our current page.  If we need to login, the login page will
    // appear.  If not, we were redirected to somewhere we didnt want to be.
    window.location.reload();
  }
  //console.log("Turbo before-fetch-response event", event);
})

function getFallback403Content(requestId = null) {
  return `
        <div class="ldp-overlay" data-action="click->ldp-navigation#hideFlexPanelOverlay" style="display: flex; justify-content: center; align-items: center; padding: 20px;">
            <div style="max-width: 600px; width: 100%;">
              <style>
                .error-page-container .c-card {
                  text-align: center;
                }
                .error-page-container img {
                  max-width: 100%;
                  max-height: 140px;
                  margin-bottom: 10px;
                }
                .error-page-container p:last-of-type {
                  margin-bottom: 16px;
                }
                .error-page-container .well {
                  margin-bottom: 0;
                }
              </style>

              <div class="c-page error-page-container">
                  <div class="row">
                    <div class="c-card col-md-12">
                      <div class="c-card__content">
                        <img src="${window.errorImageUrl}" />
                        <div class="t-title--largest">
                          The page you are trying to access is forbidden.
                        </div>
                        <p>
                          

                        </p>
                        ${requestId ? `
                          <div class="row">
                            <div class="col-md-offset-3 col-md-6">
                              <div class="well well-sm">
                                <div class="t-title">Error ID</div>
                                <tt class="request-id">${requestId}</tt>
                              </div>
                            </div>
                          </div>
                        ` : ''}
                      </div>
                    </div>
                  </div>
              </div>

            </div>
            
          </div>`
}

function getFallback500Content(requestId = null) {
  return `
        <style>
          .error-page-container .c-card {
            text-align: center;
          }
          .error-page-container img {
            max-width: 100%;
            max-height: 140px;
            margin-bottom: 10px;
          }
          .error-page-container p:last-of-type {
            margin-bottom: 16px;
          }
          .error-page-container .well {
            margin-bottom: 0;
          }
        </style>

        <div class="c-page error-page-container">
            <div class="row">
              <div class="c-card col-md-12">
                <div class="c-card__content">
                  <img src="${window.errorImageUrl}" />
                  <div class="t-title--largest">
                    Sorry, something went wrong.
                  </div>
                  <p>
                      We&#39;ve been notified about the issue and will investigate it shortly.

                  </p>
                  ${requestId ? `
                    <div class="row">
                      <div class="well well-sm">
                        <div class="t-title">Error ID</div>
                        <tt class="request-id">${requestId}</tt>
                      </div>
                    </div>
                  ` : ''}
                </div>
              </div>
            </div>
        </div>
      `
}

function logErrorToCollect(event) {
  const {statusText = 'Unknown error', status = 'Unknown status'} = event.detail.fetchResponse.response
  const requestId = event.detail.fetchResponse.response.headers.get('X-Request-Id') || null
  const message = `${status} ${statusText}`
  let environment = null;
  let baseUrl = window.routeBuilderBaseUrls?.baseUrl
  let data = null;

  if (window.Flexmls) {
    environment = Flexmls.environment;
    if (!environment) {
      // Beta is the only environment that is blank in the Flexmls object.
      // Set it explicitly.
      environment = "beta";
    }

    if (Flexmls.portalSlugPrefix) {
      baseUrl && Flexmls.portalSlugPrefix && (() => {
        // Remove the portal slug if present.
        // The Collect endpoint doesn't have a portal slug in the URL.
        // my.flexmls.com/portal_slug/c -> my.flexmls.com/c
        baseUrl = baseUrl.replace(Flexmls.portalSlugPrefix, '');
      })();
    }
    
    data = {
      D: {
        service: `app.${environment}.search.turbo.fetcherror`,
        g: "increment",
        l: true,
        message: message,
        request_id: requestId,
        app: "search",
        turbo_frame_id: event.target?.getAttribute("id") || null,
        turbo_frame_src: event.target?.getAttribute("src") || null,
        portal_slug: Flexmls.portalSlugPrefix || undefined,
        audit: {
          agent_id: Flexmls.currentUser.agent_id,
          role: Flexmls.currentUser.role,
          mls_id: Flexmls.currentUser.mls_id,
          contact_id: Flexmls.currentUser.contact_id || undefined
        }
      }
    }
  }

  if (baseUrl && environment && data) {
    axios.post(`${baseUrl}/c`, data)
      .then(() => {
        // Nothing to do here.
      })
      .catch((err) => {
        console.log("Error sending event to Collect: ", err);
      });
  } else {
    console.log("Cannot log event to Collect: baseUrl or environment are not set");
  }
}

/*
 THESE ARE ADDITIONAL TURBO EVENTS.  Keeping them commented out instead of deleting
 them in case we need to debug something in the future.
*/
/*
document.addEventListener('turbo:frame-error', function(e){
  console.log("TURBO FRAME ERROR: ", e)
});

window.addEventListener('turbo:frame-render', function(event) {
  console.log("Turbo frame-render event", event);
})

window.addEventListener('turbo:submit-start', function(event) {
  console.log("Turbo submit-start event: ", event);
})

window.addEventListener('turbo:submit-end', function(event) {
  console.log("Turbo submit-end event: ", event);
})

window.addEventListener('turbo:before-cache', function(event) {
  console.log("Turbo before-cache event");
})

window.addEventListener('turbo:before-render', function(event) {
  console.log("Turbo before-render event");
})

window.addEventListener('turbo:before-stream-render', function(event) {
  console.log("Turbo before-stream-render event");
})

window.addEventListener('turbo:render', function(event) {
  console.log("Turbo render event");
})

window.addEventListener('turbo:load', function(event) {
  console.log("Turbo load event");
})

window.addEventListener('turbo:load-error', function(event) {
  console.log("Turbo load error: ", event);
})
window.addEventListener('turbo:before-frame-render', function() {
  console.log("Turbo before-frame-render event");
})

window.addEventListener('turbo:frame-missing', function() {
  console.log("Turbo frame-missing event");
})

window.addEventListener('turbo:fetch-request-error', function() {
  console.log("Turbo fetch-request-error event");
})

*/
